export function createDecimalInputRegexWithScale(scale) {
  return new RegExp(`^-?[0-9]*(\\.|\\.[0-9]{0,${scale}})?$`);
}
